import {
  graphAmethyst,
  graphCambridgeBlue,
  graphChefchaouenBlue,
  graphLightRed,
  graphPacificCyan,
  graphPictonBlue,
  graphSandyBrown,
  graphSunglow,
  graphTropicalIndigo,
  pinkBase,
  primaryBase,
} from '../../../styles/design-tokens';

/**
 * Color palette for chart datasets.
 * First 4 match process-analysis CHART_COLORS for visual consistency,
 * then extended with additional colors for datasets beyond 4.
 * Cycles by index.
 */
const CHART_COLORS = [
  graphTropicalIndigo,
  graphLightRed,
  graphPictonBlue,
  graphSandyBrown,
  graphAmethyst,
  graphPacificCyan,
  graphChefchaouenBlue,
  primaryBase,
  graphCambridgeBlue,
];

/**
 * Phase-to-color mapping for flow_by_phase_chart.
 * Matches the existing getPhasesMetadata() pattern.
 */
const PHASE_COLORS: Record<string, string> = {
  backlog: graphTropicalIndigo,
  blocked: graphLightRed,
  wip: graphSandyBrown,
  review: graphSunglow,
  test: pinkBase,
  deployable: graphPictonBlue,
  done: primaryBase,
};

/**
 * Returns a dataset color by index, cycling through the palette.
 *
 * @param {number} index - The index of the dataset.
 * @returns {string} The corresponding color from the chart palette.
 */
function getDatasetColor(index: number): string {
  return CHART_COLORS[index % CHART_COLORS.length];
}

/**
 * Get a phase color by phase ID, falling back to the chart palette by index.
 *
 * @param {string} phaseId - The unique ID of the phase.
 * @param {number} index - The fallback index for the chart color palette.
 * @returns {string} The color code associated with the phase or a fallback color.
 */
function getPhaseColor(phaseId: string, index: number): string {
  return PHASE_COLORS[phaseId] ?? CHART_COLORS[index % CHART_COLORS.length];
}

export { getDatasetColor, getPhaseColor, PHASE_COLORS };
